import EntitySearchInput from 'components/form/EntitySearch/EntitySearchInput'
import React, { useEffect, useState } from 'react'
import Fazenda from "entity/Fazenda";
import { usePerfil } from 'useAuth';
import Cliente from 'entity/Cliente';
import { fetchArray } from 'entity';

export default function SeletorFazenda({ name = "fazenda", label = "Fazenda", cliente, fieldFilterAdd, handleFazendaChange, ...otherProps }) {
    const [uidClientes, setUidClientes] = useState(null)
    const perfil = usePerfil();
    let tipoPerfil = 'cliente'
    if (perfil) {
        if (perfil.grupoPermissao) {
            if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                tipoPerfil = 'admin'
            }
            if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                tipoPerfil = 'tecnico'
            }
            if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                tipoPerfil = 'lider'
            }
        }
    }

    useEffect(() => {
        if (cliente) {
            setUidClientes([cliente.uid]);
        } else {
            const busca = async () => {
                console.log('busca clientes')

                let uidClientesPermitidos = [];

                if (tipoPerfil === 'lider') {
                    if (perfil.clientesPermitidos && Array.isArray(perfil.clientesPermitidos) && perfil.clientesPermitidos.length > 0) {
                        uidClientesPermitidos = perfil.clientesPermitidos.map(c => c.uid);
                    }
                } else { // para técnico
                    let query = Cliente.collection.where('perfisAutorizado.' + perfil.uid, '==', true);
                    const result = await fetchArray(query.get());
                    uidClientesPermitidos = result.map(c => c.uid);
                }

                setUidClientes(uidClientesPermitidos);
            }

            if (perfil && tipoPerfil !== 'admin') {
                busca()
            }
        }

        return () => {

        }
    }, [perfil, tipoPerfil, cliente])

    const extraQuery = (col) => {

        if (perfil) {
            if (uidClientes && uidClientes.length) {
                if (uidClientes.length <= 30) {
                    col = col.where('cliente.uid', 'in', uidClientes);
                }
            }
        }
        return col;
    }
    return (
        <EntitySearchInput
            name={name}
            label={label}
            EntityClass={Fazenda}
            extraQuery={extraQuery}
            fieldFilterAdd={fieldFilterAdd}
            onChange={handleFazendaChange}
            {...otherProps}
        />
    )
}
